import React from "react";
import { useSettings } from "@/components/layout/PublicLayout";
import Seo from "@/components/shared/Seo";

const MentionsLegales = () => {
  const settings = useSettings();
  const legal = settings?.legal || {};
  return (
    <>
      <Seo title="Mentions légales — FACADES2build" description="Mentions légales du site FACADES2build." />
      <section className="bg-f2b-black pt-40 pb-16">
        <div className="f2b-container"><h1 className="font-display font-bold text-white text-4xl md:text-5xl">{legal.title || "Mentions légales"}</h1></div>
      </section>
      <section className="py-16 bg-white">
        <div className="f2b-container max-w-2xl">
          <p className="text-f2b-text/80 leading-relaxed whitespace-pre-line">{legal.content}</p>
        </div>
      </section>
    </>
  );
};

export default MentionsLegales;
